import React from 'react';

/**
 * BatcheetLogo - Ultra-modern, sleek, iconic brand mark.
 * Features dual aerodynamic conversation ribbons with an orbital 24h pulse.
 */
const BatcheetLogo = ({ size = 32, className = '' }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <defs>
                <linearGradient id="batcheetBg" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#0ea5e9" />
                    <stop offset="60%" stopColor="#3b82f6" />
                    <stop offset="100%" stopColor="#6366f1" />
                </linearGradient>
                <linearGradient id="batcheetGlow" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#38bdf8" stopOpacity="0.9" />
                    <stop offset="100%" stopColor="#818cf8" stopOpacity="0.3" />
                </linearGradient>
                <linearGradient id="batcheetSpark" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#ffffff" />
                    <stop offset="100%" stopColor="#e0f2fe" />
                </linearGradient>
            </defs>

            {/* Squircle App Frame */}
            <rect width="44" height="44" rx="14" fill="url(#batcheetBg)" />

            {/* Subtle Inner Border Glow */}
            <rect x="0.75" y="0.75" width="42.5" height="42.5" rx="13.25" stroke="white" strokeOpacity="0.2" strokeWidth="1.5" />

            {/* Primary Chat Flow Wave */}
            <path
                d="M13 18.5C13 14.3579 16.3579 11 20.5 11H23.5C27.6421 11 31 14.3579 31 18.5C31 22.6421 27.6421 26 23.5 26H18.5L14 30.5V25.5C13.3685 24.6366 13 23.5786 13 22.4V18.5Z"
                fill="url(#batcheetSpark)"
            />

            {/* Modern Electric Accent Ribbon */}
            <path
                d="M19 18C19 16.3431 20.3431 15 22 15H25C26.6569 15 28 16.3431 28 18C28 19.6569 26.6569 21 25 21H21.5L19 23.5V20.5C19 19.7 19 18.8 19 18Z"
                fill="url(#batcheetBg)"
                opacity="0.9"
            />

            {/* Live 24h Fleeting Pulse Dot */}
            <circle cx="23.5" cy="18" r="2" fill="white" />
        </svg>
    );
};

export default BatcheetLogo;
